import classes from "./PackageRed.module.css";
function PackageRed(props) {
  return (
    <div className={classes.cardContainer}>
      <div className={classes.greenline}></div>
      <div className={classes.info}>
        <h5>{props.package.Title} </h5>
      </div>
      <div className={classes.childCard}>
        <div>خریداری نشده</div>
      </div>
    </div>
  );
}
export default PackageRed;
